import { ImPhone } from "react-icons/im";

interface Props {
  callerNumber: string | null;
}
export function VoiceCallBarCallEndedView(props: Props) {
  const { callerNumber } = props;

  return (
    <>
      <div className="flex items-center gap-2">
        <ImPhone className="animate-slightRotate mr-2 size-4 text-yellow-700" />
        <span className="text-sm font-semibold">{callerNumber || "Unknown"}</span>
        <span className="text-xs text-grey-500">Call Ended</span>
      </div>
      <div className="flex items-center gap-2"></div>
    </>
  );
}
